var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupplier({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_478_9134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 12H14V26H2V12Z",
    fill: "#CCE5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 8H1C0.447715 8 0 8.44772 0 9V11C0 11.5523 0.447715 12 1 12H15C15.5523 12 16 11.5523 16 11V9C16 8.44772 15.5523 8 15 8Z",
    fill: "#027BC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58 28V32H0V26H16L20 28H58Z",
    fill: "#027BC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 32H58C58 40.83 50.83 48 42 48H16C7.17 48 0 40.83 0 32Z",
    fill: "#ECF1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 16H38V28H22V17C22 16.45 22.45 16 23 16Z",
    fill: "#019EF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 26C29.45 26 29 25.55 29 25V19C29 18.45 29.45 18 30 18C30.55 18 31 18.45 31 19V25C31 25.55 30.55 26 30 26Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 26C33.45 26 33 25.55 33 25V19C33 18.45 33.45 18 34 18C34.55 18 35 18.45 35 19V25C35 25.55 34.55 26 34 26Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 26C25.45 26 25 25.55 25 25V19C25 18.45 25.45 18 26 18C26.55 18 27 18.45 27 19V25C27 25.55 26.55 26 26 26Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 16H53C53.55 16 54 16.45 54 17V28H38V16Z",
    fill: "#027BC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46 26C45.45 26 45 25.55 45 25V19C45 18.45 45.45 18 46 18C46.55 18 47 18.45 47 19V25C47 25.55 46.55 26 46 26Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 26C49.45 26 49 25.55 49 25V19C49 18.45 49.45 18 50 18C50.55 18 51 18.45 51 19V25C51 25.55 50.55 26 50 26Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 26C41.45 26 41 25.55 41 25V19C41 18.45 41.45 18 42 18C42.55 18 43 18.45 43 19V25C43 25.55 42.55 26 42 26Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 4H45C45.55 4 46 4.45 46 5V16H30V5C30 4.45 30.45 4 31 4Z",
    fill: "#28345A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 14C37.45 14 37 13.55 37 13V7C37 6.45 37.45 6 38 6C38.55 6 39 6.45 39 7V13C39 13.55 38.55 14 38 14Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 14C41.45 14 41 13.55 41 13V7C41 6.45 41.45 6 42 6C42.55 6 43 6.45 43 7V13C43 13.55 42.55 14 42 14Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 14C33.45 14 33 13.55 33 13V7C33 6.45 33.45 6 34 6C34.55 6 35 6.45 35 7V13C35 13.55 34.55 14 34 14Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 16H12V20H4V16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 6C7.45 6 7 5.55 7 5C7 2.24 9.24 0 12 0H17C17.55 0 18 0.45 18 1C18 1.55 17.55 2 17 2H12C10.35 2 9 3.35 9 5C9 5.55 8.55 6 8 6Z",
    fill: "#E6E7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 6H12C11.45 6 11 5.55 11 5C11 4.45 11.45 4 12 4H15C15.55 4 16 4.45 16 5C16 5.55 15.55 6 15 6Z",
    fill: "#E6E7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 6H19C18.45 6 18 5.55 18 5C18 4.45 18.45 4 19 4H23C23.55 4 24 4.45 24 5C24 5.55 23.55 6 23 6Z",
    fill: "#E6E7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 2H21C20.45 2 20 1.55 20 1C20 0.45 20.45 0 21 0H23C23.55 0 24 0.45 24 1C24 1.55 23.55 2 23 2Z",
    fill: "#E6E7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57 44V50C53.5 50 53.5 52 49.99 52C46.48 52 46.49 50 42.99 50C39.49 50 39.49 52 35.99 52C32.49 52 32.49 50 28.99 50C25.49 50 25.49 52 21.99 52C18.49 52 18.49 50 14.99 50C11.49 50 11.5 52 8 52C4.5 52 4.5 50 1 50V44C4.5 44 4.5 46 8 46C11.5 46 11.5 44 14.99 44C18.48 44 18.49 46 21.99 46C25.49 46 25.49 44 28.99 44C32.49 44 32.49 46 35.99 46C39.49 46 39.49 44 42.99 44C46.49 44 46.49 46 49.99 46C53.49 46 53.5 44 57 44Z",
    fill: "#DADFF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57 50V56C53.5 56 53.5 58 49.99 58C46.48 58 46.49 56 42.99 56C39.49 56 39.49 58 35.99 58C32.49 58 32.49 56 28.99 56C25.49 56 25.49 58 21.99 58C18.49 58 18.49 56 14.99 56C11.49 56 11.5 58 8 58C4.5 58 4.5 56 1 56V50C4.5 50 4.5 52 8 52C11.5 52 11.5 50 14.99 50C18.48 50 18.49 52 21.99 52C25.49 52 25.49 50 28.99 50C32.49 50 32.49 52 35.99 52C39.49 52 39.49 50 42.99 50C46.49 50 46.49 52 49.99 52C53.49 52 53.5 50 57 50Z",
    fill: "#EFEFFD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_478_9134"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupplier);
export default __webpack_public_path__ + "static/media/supplier.632b970cca8ddfbf57277cdc18a4e6b0.svg";
export { ForwardRef as ReactComponent };